import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ThresholdSettingsDto } from 'src/app/models/settings/ThresholdSettingsDto';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-threshold',
  templateUrl: './threshold.component.html',
  styleUrl: './threshold.component.css'})
export class ThresholdComponent {

  thresholdSettings: ThresholdSettingsDto[] = [];

  /**
   *
   */
  constructor(private settingsService : SettingsService,  private router: Router) {
    
    
  }

  ngOnInit(): void {
    
    this.settingsService.getThresholdSettings().subscribe((data: ThresholdSettingsDto[]) => {
      debugger
      this.thresholdSettings = data;
    });
  }

  getAttributeId(attributeId: string) {
    switch (attributeId) {
      case 'CAN_SEND_NOTIFICATION_TO_ADMINS':
        return 'Enable threshold consumption alert notification to admins';
      case 'CAN_SEND_NOTIFICATION_TO_USERS':
        return 'Enable threshold consumption alert notification to all customers';
        default:
          return '';
      
    }
  }

  onToggleChange(event: any, thresholdSetting: ThresholdSettingsDto) {
    debugger
    const request : any = {
      settingId: thresholdSetting.settingId,
      attributeId: thresholdSetting.attributeId,
      value: event.target.checked ? '1' : '0'
    }
    this.settingsService.updateThresholdSetting(request).subscribe((data: ThresholdSettingsDto) => {
      debugger
      //this.thresholdSettings = data;
    });
  }

  goBack() {
    this.router.navigate(['/home']);
  }
}
